import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { fuseAnimations } from '../../../core/animations';
import { MatPaginator } from '@angular/material/paginator';
import {fromEvent as observableFromEvent, Subscription} from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import {NgxSpinnerService} from 'ngx-spinner';
import {FuseConfigService} from '../../../core/services/config.service';
import {LearnCategoryService} from '../../../core/services/learnCategory.service';
import {LearningPathsService} from '../../../core/services/learningPaths.service';
import {OrganizationsService} from '../../../core/services/organizations.service';

@Component({
  selector: 'app-learning-paths',
  templateUrl: './learning-paths.component.html',
  styleUrls: ['./learning-paths.component.scss'],
  animations: fuseAnimations,
  standalone: false
})
export class LearningPathsComponent implements OnInit, OnDestroy {
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public filterData: any = {};
  _pageIndex = 0;
  _perPage = 50;
  _search = '';
  _total = 0;
  learningPaths = [];
  type = '';
  status = '';
  category: any = [];
  platformId = '';
  displayedColumns = ['title' , 'visibility', 'participants', 'startDate', 'finishDate'];
  learningCategories = [];
  countryId = '';
  cityId: any = [];
  organizationId: any = [];
  visibility = '';
  private subscriptions =  new Subscription();

  constructor(private spinner: NgxSpinnerService,
              private fuseConfig: FuseConfigService, public learnCategoryService: LearnCategoryService,
              public learningPathsService: LearningPathsService, private organizationService: OrganizationsService) {
    this.subscriptions.add(this.fuseConfig.selectedPlatform.subscribe(res => {
      if (res && res.id) {
        if (res.id !== this.platformId && this.platformId) {
          this.platformId = res.id;
        }
        this.platformId = res.id;
      }
    }));
  }
  ngOnInit() {
    observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(1500),
      distinctUntilChanged())
      .subscribe(() => {
        if (this.filter.nativeElement.value && this.filter.nativeElement.value.replace(/ /g, '')
          && this.filter.nativeElement.value !== null && this.filter.nativeElement.value !== 'null') {
          this._search = this.filter.nativeElement.value;
          this.paginator.firstPage();
          this.cleanScroll();
          this.getLearningPaths();
        } else if ((!this.filter.nativeElement.value || this.filter.nativeElement.value === '') && this._search){
          this._search = '';
          this.paginator.firstPage();
          this.cleanScroll();
          this.getLearningPaths();
        }
      });
    this.filterData.learningCategories = true;
    this.filterData.learningPathsVisibility = true;
    this.getLearningPaths();
    this.getCountries();
  }

  cleanScroll () {
    const element = document.getElementById('learningPathsPage');
    if (element) {
      element.scrollTop = 0;
    }
  }

  getLearningPaths () {
    this.learningPathsService.getLearningPaths(this.organizationId, this.countryId, this.cityId,
      this.visibility, this._search, this._pageIndex, this._perPage).subscribe({
      next: (value: any) => {
        this.learningPaths = value.learningPaths;
        this._total = value.total;
      }, error: error => {}
    });
  }

  changePageEmitter (e) {
    this._pageIndex = e.pageIndex;
    this._perPage = e.pageSize;
    this.cleanScroll();
    this.getLearningPaths();
  }

  cleanAll () {
    this.countryId = '';
    this.cityId = [];
    this.organizationId = [];
    this.visibility = '';
    this._pageIndex = 0;
    this._perPage = 50;
    this._search = '';
    this.paginator.firstPage();
    this.cleanScroll();
    this.getLearningPaths();
  }

  chooseFilters(e) {
    this.paginator.firstPage();
    this.cleanScroll();
    if (e.choose === 'all') {
      delete this.filterData.cantons;
      delete this.filterData.countries;
      delete this.filterData.organizations;
      delete this.filterData.learningPathsVisibility;
      this.cleanAll();
      this.getLearningPaths();
      this.getCountries();
      setTimeout(() => {
        this.filterData.learningPathsVisibility = true;
      }, 500);
    } else if (e.choose.hasOwnProperty('country')) {
      delete this.filterData.cantons;
      delete this.filterData.organizations;
      this.getCantons(e.choose.country);
      this.countryId = e.choose.country;
      for (let i = 0; i < this.filterData.countries.length; i++) {
        this.filterData.countries[i].selected = +this.filterData.countries[i].id === +e.choose.country;
      }
      this.getLearningPaths();
    } else if (e.choose.hasOwnProperty('canton')) {
      delete this.filterData.organizations;
      this.setCities(e.choose);
      this.getLearningPaths();
      this.getOrganizations();
    } else if (e.choose.hasOwnProperty('organization')) {
      this.setOrganizations(e.choose);
      this.getLearningPaths();
    } else if (e.choose.hasOwnProperty('learningPathsVisibility')) {
      this.visibility = e.choose.learningPathsVisibility;
      this.getLearningPaths();
    }
  }

  setCities (city) {
    if (city.selected) {
      this.cityId.push(city.canton);
    } else {
      const index = this.cityId.indexOf(city.canton);
      if (index !== -1) {
        this.cityId.splice(index , 1);
      }
    }
    const uniqueArr = new Set(this.cityId);
    this.cityId = [...uniqueArr];
  }

  setOrganizations (organization) {
    if (organization.selected) {
      this.organizationId.push(organization.organization);
    } else {
      const index = this.organizationId.indexOf(organization.organization);
      if (index !== -1) {
        this.organizationId.splice(index , 1);
      }
    }
    const uniqueArr = new Set(this.organizationId);
    this.organizationId = [...uniqueArr];
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getCountries () {
    this.organizationService.getCountry().subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.countries = res;
        this.getLearningPaths();
      } else if (res.length === 1) {
        this.countryId = res[ 0 ].id;
        this.getCantons(res[ 0 ].id);
        delete this.filterData.countries;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  getCantons (id) {
    this.organizationService.getCity(id).subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.cantons = res;
        this.getLearningPaths();
      } else if (res.length === 1) {
        this.cityId = res[ 0 ].id;
        this.getOrganizations();
        delete this.filterData.cantons;
      } else {
        delete this.filterData.cantons;
        this.getLearningPaths();
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  getOrganizations () {
    this.organizationService.getOrganizationByCantonId(this.cityId).subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.organizations = res;
        this.getLearningPaths();
      } else if (res.length === 1) {
        this.organizationId = res[ 0 ].id;
        this.getLearningPaths();
        delete this.filterData.organizations;
      } else {
        delete this.filterData.organizations;
        this.getLearningPaths();
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }
}
